import styled from 'styled-components';
import VerificationInput from 'react-verification-input';
import { FONT_SIZE, FONT_WEIGHT, media } from '@app/styles/themes/constants';
import { themeObject } from '@app/styles/themes/themeVariables';

export const CodeInput = styled(VerificationInput)`
  display: flex;
  gap: 0.5rem;

  .character {
    line-height: 4.5rem;
    font-size: ${FONT_SIZE.xxl};
    font-weight: ${FONT_WEIGHT.bold};
    color: ${themeObject.light.textMain};
    border: 3px solid var(--lightgrey);
    border-radius: 0.625rem;
    width: 2.875rem;
    height: 4.5rem;
  }

  .character--inactive {
    border: 3px solid var(--lightgrey);
  }

  .character--selected {
    border: 3px solid var(--primary-color);
  }

  @media only screen and ${media.xs} {
    gap: 0.375rem;
    .character {
      width: 2.0625rem;
      height: 3.25rem;
      line-height: 3.25rem;
    }
  }

  @media only screen and ${media.md} {
    gap: 0.5rem;
    .character {
      width: 2.875rem;
      height: 4.5rem;
      line-height: 4.5rem;
    }
  }

  @media only screen and ${media.xl} {
    gap: 0.5rem;
    .character {
      width: 2.875rem;
      height: 4.5rem;
      line-height: 4.5rem;
    }
  }
`;
